// ============================================================
// User Preferences API
// ============================================================
// Per-user UI preferences persisted server-side so they follow
// the admin across browsers and devices.
//
// Backend contract (expected, see BE team):
//   GET  /api/v1/admin/preferences            -> ResponseDTO<Record<string, unknown>>
//   PUT  /api/v1/admin/preferences            -> ResponseDTO<Record<string, unknown>>
//     body: { key: string, value: unknown }
//
// Until the endpoint is live, callers should treat fetch failures
// as "no remote value" and fall back to a local default.
// ============================================================

import { apiGet, apiPut, unwrap } from "./apiClient";
import { ResponseDTO } from "@/types/api";

export type UserPreferences = Record<string, unknown>;

export async function getUserPreferences(): Promise<UserPreferences> {
  const res = await apiGet<ResponseDTO<UserPreferences>>(
    "/api/v1/admin/preferences"
  );
  return unwrap(res) ?? {};
}

export async function updateUserPreference<T>(
  key: string,
  value: T
): Promise<UserPreferences> {
  const res = await apiPut<ResponseDTO<UserPreferences>>(
    "/api/v1/admin/preferences",
    { key, value }
  );
  return unwrap(res) ?? {};
}
